import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  InputGroup,
  Form,
  Toast,
} from "react-bootstrap";
import {
  fetchPrograms,
  fetchPlaylists,
  postNowPlaying,
} from "./services/DataService";
import { datetimeToString } from "./services/UtilityService";
import DateTimePicker from "react-datetime-picker";
import DJ from "./DJ.js";
import { Redirect } from "react-router-dom";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

class OnAir extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      now_playing_validated: false,
      playlist_validated: false,
      toast: false,
      toastText: "",
      song: "",
      artist: "",
      album: "",
      now_playing_datetime: new Date(),
      programs: [],
      playlists: [],
    };
    this.submitNowPlaying = this.submitNowPlaying.bind(this);
  }

  componentDidMount() {
    fetchPrograms([]).then(
      (programs) => {
        fetchPlaylists().then((playlists) => {
          if (!playlists) {
            playlists = [];
          }
          this.setState({
            loading: false,
            programs: programs ?? [],
            playlists: playlists,
            selectedPlaylistID: parseInt(playlists[0].id),
          });
        });
      },
      ["current=true"]
    );
  }

  submitNowPlaying(event) {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      this.setState({ now_playing_validated: false });
      return;
    }
    this.setState({ now_playing_validated: true });
    let np = {};
    const data = new FormData(form);
    let it = data.entries();
    let result = it.next();
    while (!result.done) {
      let key = result.value[0];
      let value = result.value[1];
      if (["day", "hour12", "minute", "month", "amPm", "year"].includes(key)) {
        result = it.next();
        continue;
      }
      if (["program_id"].includes(key)) value = parseInt(value);
      np[key] = value;
      result = it.next();
    }
    np["play_time"] = datetimeToString(this.state.now_playing_datetime);
    postNowPlaying(np).then((_) => {
      this.setState({
        toast: true,
        toastText: `${np.title} by ${np.artist}`,
        now_playing_validated: false,
      });
      form.reset();
    });
  }

  programToString = (program) => {
    let timeToString = (time) => {
      let ampm = "am";
      let time_parts = time.split(":");
      let hour = parseInt(time_parts[0]);
      let minute = parseInt(time_parts[1]);
      if (hour > 12) {
        hour -= 12;
        ampm = "pm";
      }
      if (hour === 0) hour = 12;
      if (minute < 9) minute = `0${minute}`;
      return `${hour}:${minute} ${ampm}`;
    };
    let days = [];
    if (program.sunday) days.push("S");
    if (program.monday) days.push("M");
    if (program.tuesday) days.push("T");
    if (program.wednesday) days.push("W");
    if (program.thursday) days.push("Th");
    if (program.friday) days.push("F");
    if (program.saturday) days.push("Sa");
    let start_time = timeToString(program.start_time);
    let end_time = timeToString(program.end_time);

    return `${program.name} (${days.join("")}, ${start_time} - ${end_time})`;
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    if (this.state.submitPlaylist && this.state.selectedPlaylistID) {
      return <DJ playlistID={this.state.selectedPlaylistID} />;
    }
    return (
      <Container fluid>
        <Row className="mb-4">
          <Col>
            <h1>On-Air</h1>
          </Col>
        </Row>
        <Form
          noValidate
          validated={this.state.now_playing_validated}
          onSubmit={this.submitNowPlaying}
        >
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Control
                required
                name="title"
                aria-label="Title"
                aria-describedby="title-label"
                placeholder="Title"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a title.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Control
                required
                name="artist"
                aria-label="Artist"
                aria-describedby="artist-label"
                placeholder="Artist"
              />
              <Form.Control.Feedback type="invalid">
                Please provide an artist.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Control
                required
                name="album"
                aria-label="Album"
                aria-describedby="album-label"
                placeholder="Album"
              />
              <Form.Control.Feedback type="invalid">
                Please provide an album.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Control
                name="label"
                aria-label="Label"
                aria-describedby="label-label"
                placeholder="Label"
              />
            </Form.Group>
          </Row>
          <Row className="mb-4">
            <Col md="6">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="program-label">Program</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control as="select" name="program_id">
                  {this.state.programs.map((program) => {
                    return (
                      <option key={program.id} value={program.id}>
                        {this.programToString(program)}
                      </option>
                    );
                  })}
                </Form.Control>
              </InputGroup>
            </Col>
            <Col md="6">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="program-label">Time</InputGroup.Text>
                </InputGroup.Prepend>
                <DateTimePicker
                  className="form-control"
                  value={this.state.now_playing_datetime}
                  onChange={(dt) => {
                    this.setState({ now_playing_datetime: dt });
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <Button type="submit">Submit</Button>
            </Col>
          </Row>
        </Form>

        <Row className="mb-4"></Row>

        <Row className="mb-4">
          <Col>
            <h2>Playlist</h2>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="6">
            <InputGroup>
              <Form.Control
                as="select"
                onChange={(e) => {
                  this.setState({
                    selectedPlaylistID: parseInt(e.target.value),
                  });
                }}
                name="playlist_id"
              >
                {this.state.playlists.map((playlist) => {
                  return (
                    <option key={playlist.id} value={playlist.id}>
                      {playlist.name}
                    </option>
                  );
                })}
              </Form.Control>
            </InputGroup>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <Button
              type="submit"
              onClick={() => {
                this.setState({ submitPlaylist: true });
              }}
            >
              Submit
            </Button>
          </Col>
        </Row>

        <Toast
          onClose={() => this.setState({ toast: false })}
          show={this.state.toast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded mr-2"
              alt=""
            />
            <strong className="mr-auto">Now Playing</strong>
            <small>{this.state.toastText}</small>
          </Toast.Header>
        </Toast>
      </Container>
    );
  }
}

export default OnAir;
